import { CSSProperties } from "react";

export const STYLES = {
  hideScrollbar: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    WebkitOverflowScrolling: 'touch',
  },
  imageBlur: {
    pointerEvents: 'none',
    filter: 'blur(10px)',
    transform: 'scale(1.1)', // Prevent edge-halo effect
  },
} as Record<string, CSSProperties>;
